import { Icon } from '@/components/icon';
import { Section } from '@/components/section';
import { generalFAQ } from '@/data/faq';

export function FAQSection(): React.ReactNode {
  return (
    <Section background="bone">
      <div className="mx-auto max-w-3xl">
        <h2 className="mb-8 text-3xl font-semibold sm:text-4xl">Häufige Fragen</h2>
        <dl className="space-y-3">
          {generalFAQ.map((item) => (
            <details
              key={item.question}
              className="group rounded-lg border border-stone bg-paper p-5"
            >
              <summary className="flex cursor-pointer items-center justify-between gap-4 font-medium">
                <span>{item.question}</span>
                <Icon
                  name="Plus"
                  className="h-5 w-5 shrink-0 text-mute transition-transform group-open:rotate-45"
                />
              </summary>
              <p className="mt-3 text-mute">{item.answer}</p>
            </details>
          ))}
        </dl>
      </div>
    </Section>
  );
}
